// Two parallel mappings because the data stores language differently per
// collection:
//   - `education-programs.language`       → "French", "German", … (full name)
//   - `education-courses.courseLanguage`  → "fr", "de", … (ISO code)
// The UI locale is the ISO code from the URL (`/fr-fr/...` → "fr"), with
// the exception of "ua" which maps to "uk" on the course side.
const LOCALE_TO_PROGRAM_LANGUAGE = {
  ua: 'Ukrainian',
  bg: 'Bulgarian',
  ca: 'Catalan',
  cs: 'Czech',
  da: 'Danish',
  de: 'German',
  el: 'Greek',
  en: 'English',
  es: 'Spanish',
  et: 'Estonian',
  fi: 'Finnish',
  fr: 'French',
  hr: 'Croatian',
  hu: 'Hungarian',
  hy: 'Armenian',
  is: 'Icelandic',
  it: 'Italian',
  ka: 'Georgian',
  lt: 'Lithuanian',
  lv: 'Latvian',
  mk: 'Macedonian',
  nl: 'Dutch',
  no: 'Norwegian',
  pl: 'Polish',
  pt: 'Portuguese',
  ro: 'Romanian',
  ru: 'Russian',
  sk: 'Slovak',
  sl: 'Slovenian',
  sq: 'Albanian',
  sr: 'Serbian',
  sv: 'Swedish',
  tr: 'Turkish'
};

const LOCALE_TO_COURSE_LANGUAGE = {
  ua: 'uk' // courses use the ISO code "uk" for Ukrainian
};

// Returns [<locale's language>, 'English'] (deduped) for filtering programs.
const getProgramLanguageFilter = (locale) => {
  const primary = LOCALE_TO_PROGRAM_LANGUAGE[locale];
  if (!primary || primary === 'English') return ['English'];
  return [primary, 'English'];
};

// Returns [<locale's ISO>, 'en'] (deduped) for filtering courses.
const getCourseLanguageFilter = (locale) => {
  const primary = LOCALE_TO_COURSE_LANGUAGE[locale] || locale;
  if (!primary || primary === 'en') return ['en'];
  return [primary, 'en'];
};

export default getProgramLanguageFilter;
export { getCourseLanguageFilter, LOCALE_TO_PROGRAM_LANGUAGE };
